import { t } from '@lingui/core/macro'
import { AccountFieldManager, AuthFieldType } from '../components'
import { AccountType } from '../types'

const SALESFORCE_MARKETING_CLOUD_SUBDOMAIN_KEY = 'subdomain'
const SALESFORCE_MARKETING_CLOUD_ACCOUNT_ID_KEY = 'account_id'
const SALESFORCE_MARKETING_CLOUD_CLIENT_ID_KEY = 'client_id'
const SALESFORCE_MARKETING_CLOUD_CLIENT_SECRET_KEY = 'client_secret'

interface SalesforceMarketingCloudProps {
  newConnection: boolean
  updatedAccount: AccountType
  setRequiredFieldMissing: (fieldsMissing: boolean) => void
  setUpdatedAccount: (updatedAccount: AccountType) => void
}

export const SalesforceMarketingCloud = ({
  updatedAccount,
  setUpdatedAccount,
  setRequiredFieldMissing,
  newConnection,
}: SalesforceMarketingCloudProps) => {
  const SalesforceMarketingCloudFields: AuthFieldType[] = [
    {
      fieldValue: updatedAccount.metadata.subdomain,
      fieldKey: SALESFORCE_MARKETING_CLOUD_SUBDOMAIN_KEY,
      fieldLabel: t`Subdomain`,
    },
    {
      fieldValue: updatedAccount.metadata.account_id,
      fieldKey: SALESFORCE_MARKETING_CLOUD_ACCOUNT_ID_KEY,
      fieldLabel: t`Account Id`,
    },
    {
      fieldValue: updatedAccount.metadata.client_id,
      fieldKey: SALESFORCE_MARKETING_CLOUD_CLIENT_ID_KEY,
      fieldLabel: t`Client Id`,
    },
    {
      fieldValue: updatedAccount.metadata.client_secret,
      fieldKey: SALESFORCE_MARKETING_CLOUD_CLIENT_SECRET_KEY,
      fieldLabel: t`Client Secret`,
    },
  ]

  return (
    <AccountFieldManager
      newConnection={newConnection}
      updatedAccount={updatedAccount}
      setUpdatedAccount={setUpdatedAccount}
      accountFields={SalesforceMarketingCloudFields}
      setRequiredFieldsMissing={setRequiredFieldMissing}
    />
  )
}
